import type { FC, PropsWithChildren } from 'react'

import type { TreeProps } from 'react-organizational-chart'
import { Tree } from 'react-organizational-chart'

export const RootNode: FC<PropsWithChildren<TreeProps>> = ({ label, children, ...restOfProps }) => (
  <Tree label={label} lineWidth="2px" lineColor="#888" {...restOfProps}>
    {children}
  </Tree>
)
